/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminDashboardQueryParams { 
    /**
     * Account id (partner or merchant)
     */
    account_id: string;
    /**
     * Date of the end of the data to include in the summary.
     */
    end_at: string;
    /**
     * Date of the start of the data to include in the summary.
     */
    start_at: string;
    /**
     * String indicating the unit of time to aggregate the summary of data.
     */
    time_unit?: AdminDashboardQueryParams.TimeUnitEnum;
    /**
     * Time Zone by which to aggregate the results. Default is \"America/New_York\".
     */
    time_zone?: AdminDashboardQueryParams.TimeZoneEnum;
}
export namespace AdminDashboardQueryParams {
    export type TimeUnitEnum = 'day' | 'week' | 'month' | 'year';
    export const TimeUnitEnum = {
        DAY: 'day' as TimeUnitEnum,
        WEEK: 'week' as TimeUnitEnum,
        MONTH: 'month' as TimeUnitEnum,
        YEAR: 'year' as TimeUnitEnum
    };
    export type TimeZoneEnum = 'Africa/Abidjan' | 'Africa/Accra' | 'Africa/Addis_Ababa' | 'Africa/Algiers' | 'Africa/Asmara' | 'Africa/Asmera' | 'Africa/Bamako' | 'Africa/Bangui' | 'Africa/Banjul' | 'Africa/Bissau' | 'Africa/Blantyre' | 'Africa/Brazzaville' | 'Africa/Bujumbura' | 'Africa/Cairo' | 'Africa/Casablanca' | 'Africa/Ceuta' | 'Africa/Conakry' | 'Africa/Dakar' | 'Africa/Dar_es_Salaam' | 'Africa/Djibouti' | 'Africa/Douala' | 'Africa/El_Aaiun' | 'Africa/Freetown' | 'Africa/Gaborone' | 'Africa/Harare' | 'Africa/Johannesburg' | 'Africa/Juba' | 'Africa/Kampala' | 'Africa/Khartoum' | 'Africa/Kigali' | 'Africa/Kinshasa' | 'Africa/Lagos' | 'Africa/Libreville' | 'Africa/Lome' | 'Africa/Luanda' | 'Africa/Lubumbashi' | 'Africa/Lusaka' | 'Africa/Malabo' | 'Africa/Maputo' | 'Africa/Maseru' | 'Africa/Mbabane' | 'Africa/Mogadishu' | 'Africa/Monrovia' | 'Africa/Nairobi' | 'Africa/Ndjamena' | 'Africa/Niamey' | 'Africa/Nouakchott' | 'Africa/Ouagadougou' | 'Africa/Porto-Novo' | 'Africa/Sao_Tome' | 'Africa/Timbuktu' | 'Africa/Tripoli' | 'Africa/Tunis' | 'Africa/Windhoek' | 'America/Adak' | 'America/Anchorage' | 'America/Anguilla' | 'America/Antigua' | 'America/Araguaina' | 'America/Argentina/Buenos_Aires' | 'America/Argentina/Catamarca' | 'America/Argentina/ComodRivadavia' | 'America/Argentina/Cordoba' | 'America/Argentina/Jujuy' | 'America/Argentina/La_Rioja' | 'America/Argentina/Mendoza' | 'America/Argentina/Rio_Gallegos' | 'America/Argentina/Salta' | 'America/Argentina/San_Juan' | 'America/Argentina/San_Luis' | 'America/Argentina/Tucuman' | 'America/Argentina/Ushuaia' | 'America/Aruba' | 'America/Asuncion' | 'America/Atikokan' | 'America/Atka' | 'America/Bahia' | 'America/Bahia_Banderas' | 'America/Barbados' | 'America/Belem' | 'America/Belize' | 'America/Blanc-Sablon' | 'America/Boa_Vista' | 'America/Bogota' | 'America/Boise' | 'America/Buenos_Aires' | 'America/Cambridge_Bay' | 'America/Campo_Grande' | 'America/Cancun' | 'America/Caracas' | 'America/Catamarca' | 'America/Cayenne' | 'America/Cayman' | 'America/Chicago' | 'America/Chihuahua' | 'America/Coral_Harbour' | 'America/Cordoba' | 'America/Costa_Rica' | 'America/Creston' | 'America/Cuiaba' | 'America/Curacao' | 'America/Danmarkshavn' | 'America/Dawson' | 'America/Dawson_Creek' | 'America/Denver' | 'America/Detroit' | 'America/Dominica' | 'America/Edmonton' | 'America/Eirunepe' | 'America/El_Salvador' | 'America/Ensenada' | 'America/Fort_Wayne' | 'America/Fortaleza' | 'America/Glace_Bay' | 'America/Godthab' | 'America/Goose_Bay' | 'America/Grand_Turk' | 'America/Grenada' | 'America/Guadeloupe' | 'America/Guatemala' | 'America/Guayaquil' | 'America/Guyana' | 'America/Halifax' | 'America/Havana' | 'America/Hermosillo' | 'America/Indiana/Indianapolis' | 'America/Indiana/Knox' | 'America/Indiana/Marengo' | 'America/Indiana/Petersburg' | 'America/Indiana/Tell_City' | 'America/Indiana/Vevay' | 'America/Indiana/Vincennes' | 'America/Indiana/Winamac' | 'America/Indianapolis' | 'America/Inuvik' | 'America/Iqaluit' | 'America/Jamaica' | 'America/Jujuy' | 'America/Juneau' | 'America/Kentucky/Louisville' | 'America/Kentucky/Monticello' | 'America/Knox_IN' | 'America/Kralendijk' | 'America/La_Paz' | 'America/Lima' | 'America/Los_Angeles' | 'America/Louisville' | 'America/Lower_Princes' | 'America/Maceio' | 'America/Managua' | 'America/Manaus' | 'America/Marigot' | 'America/Martinique' | 'America/Matamoros' | 'America/Mazatlan' | 'America/Mendoza' | 'America/Menominee' | 'America/Merida' | 'America/Metlakatla' | 'America/Mexico_City' | 'America/Miquelon' | 'America/Moncton' | 'America/Monterrey' | 'America/Montevideo' | 'America/Montreal' | 'America/Montserrat' | 'America/Nassau' | 'America/New_York' | 'America/Nipigon' | 'America/Nome' | 'America/Noronha' | 'America/North_Dakota/Beulah' | 'America/North_Dakota/Center' | 'America/North_Dakota/New_Salem' | 'America/Ojinaga' | 'America/Panama' | 'America/Pangnirtung' | 'America/Paramaribo' | 'America/Phoenix' | 'America/Port-au-Prince' | 'America/Port_of_Spain' | 'America/Porto_Acre' | 'America/Porto_Velho' | 'America/Puerto_Rico' | 'America/Rainy_River' | 'America/Rankin_Inlet' | 'America/Recife' | 'America/Regina' | 'America/Resolute' | 'America/Rio_Branco' | 'America/Rosario' | 'America/Santa_Isabel' | 'America/Santarem' | 'America/Santiago' | 'America/Santo_Domingo' | 'America/Sao_Paulo' | 'America/Scoresbysund' | 'America/Shiprock' | 'America/Sitka' | 'America/St_Barthelemy' | 'America/St_Johns' | 'America/St_Kitts' | 'America/St_Lucia' | 'America/St_Thomas' | 'America/St_Vincent' | 'America/Swift_Current' | 'America/Tegucigalpa' | 'America/Thule' | 'America/Thunder_Bay' | 'America/Tijuana' | 'America/Toronto' | 'America/Tortola' | 'America/Vancouver' | 'America/Virgin' | 'America/Whitehorse' | 'America/Winnipeg' | 'America/Yakutat' | 'America/Yellowknife' | 'Antarctica/Casey' | 'Antarctica/Davis' | 'Antarctica/DumontDUrville' | 'Antarctica/Macquarie' | 'Antarctica/Mawson' | 'Antarctica/McMurdo' | 'Antarctica/Palmer' | 'Antarctica/Rothera' | 'Antarctica/South_Pole' | 'Antarctica/Syowa' | 'Antarctica/Troll' | 'Antarctica/Vostok' | 'Arctic/Longyearbyen' | 'Asia/Aden' | 'Asia/Almaty' | 'Asia/Amman' | 'Asia/Anadyr' | 'Asia/Aqtau' | 'Asia/Aqtobe' | 'Asia/Ashgabat' | 'Asia/Ashkhabad' | 'Asia/Baghdad' | 'Asia/Bahrain' | 'Asia/Baku' | 'Asia/Bangkok' | 'Asia/Beirut' | 'Asia/Bishkek' | 'Asia/Brunei' | 'Asia/Calcutta' | 'Asia/Chita' | 'Asia/Choibalsan' | 'Asia/Chongqing' | 'Asia/Chungking' | 'Asia/Colombo' | 'Asia/Dacca' | 'Asia/Damascus' | 'Asia/Dhaka' | 'Asia/Dili' | 'Asia/Dubai' | 'Asia/Dushanbe' | 'Asia/Gaza' | 'Asia/Harbin' | 'Asia/Hebron' | 'Asia/Ho_Chi_Minh' | 'Asia/Hong_Kong' | 'Asia/Hovd' | 'Asia/Irkutsk' | 'Asia/Istanbul' | 'Asia/Jakarta' | 'Asia/Jayapura' | 'Asia/Jerusalem' | 'Asia/Kabul' | 'Asia/Kamchatka' | 'Asia/Karachi' | 'Asia/Kashgar' | 'Asia/Kathmandu' | 'Asia/Katmandu' | 'Asia/Khandyga' | 'Asia/Kolkata' | 'Asia/Krasnoyarsk' | 'Asia/Kuala_Lumpur' | 'Asia/Kuching' | 'Asia/Kuwait' | 'Asia/Macao' | 'Asia/Macau' | 'Asia/Magadan' | 'Asia/Makassar' | 'Asia/Manila' | 'Asia/Muscat' | 'Asia/Nicosia' | 'Asia/Novokuznetsk' | 'Asia/Novosibirsk' | 'Asia/Omsk' | 'Asia/Oral' | 'Asia/Phnom_Penh' | 'Asia/Pontianak' | 'Asia/Pyongyang' | 'Asia/Qatar' | 'Asia/Qyzylorda' | 'Asia/Rangoon' | 'Asia/Riyadh' | 'Asia/Saigon' | 'Asia/Sakhalin' | 'Asia/Samarkand' | 'Asia/Seoul' | 'Asia/Shanghai' | 'Asia/Singapore' | 'Asia/Srednekolymsk' | 'Asia/Taipei' | 'Asia/Tashkent' | 'Asia/Tbilisi' | 'Asia/Tehran' | 'Asia/Tel_Aviv' | 'Asia/Thimbu' | 'Asia/Thimphu' | 'Asia/Tokyo' | 'Asia/Ujung_Pandang' | 'Asia/Ulaanbaatar' | 'Asia/Ulan_Bator' | 'Asia/Urumqi' | 'Asia/Ust-Nera' | 'Asia/Vientiane' | 'Asia/Vladivostok' | 'Asia/Yakutsk' | 'Asia/Yekaterinburg' | 'Asia/Yerevan' | 'Atlantic/Azores' | 'Atlantic/Bermuda' | 'Atlantic/Canary' | 'Atlantic/Cape_Verde' | 'Atlantic/Faeroe' | 'Atlantic/Faroe' | 'Atlantic/Jan_Mayen' | 'Atlantic/Madeira' | 'Atlantic/Reykjavik' | 'Atlantic/South_Georgia' | 'Atlantic/St_Helena' | 'Atlantic/Stanley' | 'Australia/ACT' | 'Australia/Adelaide' | 'Australia/Brisbane' | 'Australia/Broken_Hill' | 'Australia/Canberra' | 'Australia/Currie' | 'Australia/Darwin' | 'Australia/Eucla' | 'Australia/Hobart' | 'Australia/LHI' | 'Australia/Lindeman' | 'Australia/Lord_Howe' | 'Australia/Melbourne' | 'Australia/NSW' | 'Australia/North' | 'Australia/Perth' | 'Australia/Queensland' | 'Australia/South' | 'Australia/Sydney' | 'Australia/Tasmania' | 'Australia/Victoria' | 'Australia/West' | 'Australia/Yancowinna' | 'Brazil/Acre' | 'Brazil/DeNoronha' | 'Brazil/East' | 'Brazil/West' | 'Canada/Atlantic' | 'Canada/Central' | 'Canada/East-Saskatchewan' | 'Canada/Eastern' | 'Canada/Mountain' | 'Canada/Newfoundland' | 'Canada/Pacific' | 'Canada/Saskatchewan' | 'Canada/Yukon' | 'Chile/Continental' | 'Chile/EasterIsland' | 'Etc/GMT' | 'Etc/GMT+0' | 'Etc/GMT+1' | 'Etc/GMT+10' | 'Etc/GMT+11' | 'Etc/GMT+12' | 'Etc/GMT+2' | 'Etc/GMT+3' | 'Etc/GMT+4' | 'Etc/GMT+5' | 'Etc/GMT+6' | 'Etc/GMT+7' | 'Etc/GMT+8' | 'Etc/GMT+9' | 'Etc/GMT-0' | 'Etc/GMT-1' | 'Etc/GMT-10' | 'Etc/GMT-11' | 'Etc/GMT-12' | 'Etc/GMT-13' | 'Etc/GMT-14' | 'Etc/GMT-2' | 'Etc/GMT-3' | 'Etc/GMT-4' | 'Etc/GMT-5' | 'Etc/GMT-6' | 'Etc/GMT-7' | 'Etc/GMT-8' | 'Etc/GMT-9' | 'Etc/Greenwich' | 'Etc/UCT' | 'Etc/UTC' | 'Etc/Universal' | 'Etc/Zulu' | 'Europe/Amsterdam' | 'Europe/Andorra' | 'Europe/Athens' | 'Europe/Belfast' | 'Europe/Belgrade' | 'Europe/Berlin' | 'Europe/Bratislava' | 'Europe/Brussels' | 'Europe/Bucharest' | 'Europe/Budapest' | 'Europe/Busingen' | 'Europe/Chisinau' | 'Europe/Copenhagen' | 'Europe/Dublin' | 'Europe/Gibraltar' | 'Europe/Guernsey' | 'Europe/Helsinki' | 'Europe/Isle_of_Man' | 'Europe/Istanbul' | 'Europe/Jersey' | 'Europe/Kaliningrad' | 'Europe/Kiev' | 'Europe/Lisbon' | 'Europe/Ljubljana' | 'Europe/London' | 'Europe/Luxembourg' | 'Europe/Madrid' | 'Europe/Malta' | 'Europe/Mariehamn' | 'Europe/Minsk' | 'Europe/Monaco' | 'Europe/Moscow' | 'Europe/Nicosia' | 'Europe/Oslo' | 'Europe/Paris' | 'Europe/Podgorica' | 'Europe/Prague' | 'Europe/Riga' | 'Europe/Rome' | 'Europe/Samara' | 'Europe/San_Marino' | 'Europe/Sarajevo' | 'Europe/Simferopol' | 'Europe/Skopje' | 'Europe/Sofia' | 'Europe/Stockholm' | 'Europe/Tallinn' | 'Europe/Tirane' | 'Europe/Tiraspol' | 'Europe/Uzhgorod' | 'Europe/Vaduz' | 'Europe/Vatican' | 'Europe/Vienna' | 'Europe/Vilnius' | 'Europe/Volgograd' | 'Europe/Warsaw' | 'Europe/Zagreb' | 'Europe/Zaporozhye' | 'Europe/Zurich' | 'Indian/Antananarivo' | 'Indian/Chagos' | 'Indian/Christmas' | 'Indian/Cocos' | 'Indian/Comoro' | 'Indian/Kerguelen' | 'Indian/Mahe' | 'Indian/Maldives' | 'Indian/Mauritius' | 'Indian/Mayotte' | 'Indian/Reunion' | 'Mexico/BajaNorte' | 'Mexico/BajaSur' | 'Mexico/General' | 'Pacific/Apia' | 'Pacific/Auckland' | 'Pacific/Chatham' | 'Pacific/Chuuk' | 'Pacific/Easter' | 'Pacific/Efate' | 'Pacific/Enderbury' | 'Pacific/Fakaofo' | 'Pacific/Fiji' | 'Pacific/Funafuti' | 'Pacific/Galapagos' | 'Pacific/Gambier' | 'Pacific/Guadalcanal' | 'Pacific/Guam' | 'Pacific/Honolulu' | 'Pacific/Johnston' | 'Pacific/Kiritimati' | 'Pacific/Kosrae' | 'Pacific/Kwajalein' | 'Pacific/Majuro' | 'Pacific/Marquesas' | 'Pacific/Midway' | 'Pacific/Nauru' | 'Pacific/Niue' | 'Pacific/Norfolk' | 'Pacific/Noumea' | 'Pacific/Pago_Pago' | 'Pacific/Palau' | 'Pacific/Pitcairn' | 'Pacific/Pohnpei' | 'Pacific/Ponape' | 'Pacific/Port_Moresby' | 'Pacific/Rarotonga' | 'Pacific/Saipan' | 'Pacific/Samoa' | 'Pacific/Tahiti' | 'Pacific/Tarawa' | 'Pacific/Tongatapu' | 'Pacific/Truk' | 'Pacific/Wake' | 'Pacific/Wallis' | 'Pacific/Yap';
    export const TimeZoneEnum = {
        AFRICA_ABIDJAN: 'Africa/Abidjan' as TimeZoneEnum,
        AFRICA_ACCRA: 'Africa/Accra' as TimeZoneEnum,
        AFRICA_ADDIS_ABABA: 'Africa/Addis_Ababa' as TimeZoneEnum,
        AFRICA_ALGIERS: 'Africa/Algiers' as TimeZoneEnum,
        AFRICA_ASMARA: 'Africa/Asmara' as TimeZoneEnum,
        AFRICA_ASMERA: 'Africa/Asmera' as TimeZoneEnum,
        AFRICA_BAMAKO: 'Africa/Bamako' as TimeZoneEnum,
        AFRICA_BANGUI: 'Africa/Bangui' as TimeZoneEnum,
        AFRICA_BANJUL: 'Africa/Banjul' as TimeZoneEnum,
        AFRICA_BISSAU: 'Africa/Bissau' as TimeZoneEnum,
        AFRICA_BLANTYRE: 'Africa/Blantyre' as TimeZoneEnum,
        AFRICA_BRAZZAVILLE: 'Africa/Brazzaville' as TimeZoneEnum,
        AFRICA_BUJUMBURA: 'Africa/Bujumbura' as TimeZoneEnum,
        AFRICA_CAIRO: 'Africa/Cairo' as TimeZoneEnum,
        AFRICA_CASABLANCA: 'Africa/Casablanca' as TimeZoneEnum,
        AFRICA_CEUTA: 'Africa/Ceuta' as TimeZoneEnum,
        AFRICA_CONAKRY: 'Africa/Conakry' as TimeZoneEnum,
        AFRICA_DAKAR: 'Africa/Dakar' as TimeZoneEnum,
        AFRICA_DAR_ES_SALAAM: 'Africa/Dar_es_Salaam' as TimeZoneEnum,
        AFRICA_DJIBOUTI: 'Africa/Djibouti' as TimeZoneEnum,
        AFRICA_DOUALA: 'Africa/Douala' as TimeZoneEnum,
        AFRICA_EL_AAIUN: 'Africa/El_Aaiun' as TimeZoneEnum,
        AFRICA_FREETOWN: 'Africa/Freetown' as TimeZoneEnum,
        AFRICA_GABORONE: 'Africa/Gaborone' as TimeZoneEnum,
        AFRICA_HARARE: 'Africa/Harare' as TimeZoneEnum,
        AFRICA_JOHANNESBURG: 'Africa/Johannesburg' as TimeZoneEnum,
        AFRICA_JUBA: 'Africa/Juba' as TimeZoneEnum,
        AFRICA_KAMPALA: 'Africa/Kampala' as TimeZoneEnum,
        AFRICA_KHARTOUM: 'Africa/Khartoum' as TimeZoneEnum,
        AFRICA_KIGALI: 'Africa/Kigali' as TimeZoneEnum,
        AFRICA_KINSHASA: 'Africa/Kinshasa' as TimeZoneEnum,
        AFRICA_LAGOS: 'Africa/Lagos' as TimeZoneEnum,
        AFRICA_LIBREVILLE: 'Africa/Libreville' as TimeZoneEnum,
        AFRICA_LOME: 'Africa/Lome' as TimeZoneEnum,
        AFRICA_LUANDA: 'Africa/Luanda' as TimeZoneEnum,
        AFRICA_LUBUMBASHI: 'Africa/Lubumbashi' as TimeZoneEnum,
        AFRICA_LUSAKA: 'Africa/Lusaka' as TimeZoneEnum,
        AFRICA_MALABO: 'Africa/Malabo' as TimeZoneEnum,
        AFRICA_MAPUTO: 'Africa/Maputo' as TimeZoneEnum,
        AFRICA_MASERU: 'Africa/Maseru' as TimeZoneEnum,
        AFRICA_MBABANE: 'Africa/Mbabane' as TimeZoneEnum,
        AFRICA_MOGADISHU: 'Africa/Mogadishu' as TimeZoneEnum,
        AFRICA_MONROVIA: 'Africa/Monrovia' as TimeZoneEnum,
        AFRICA_NAIROBI: 'Africa/Nairobi' as TimeZoneEnum,
        AFRICA_NDJAMENA: 'Africa/Ndjamena' as TimeZoneEnum,
        AFRICA_NIAMEY: 'Africa/Niamey' as TimeZoneEnum,
        AFRICA_NOUAKCHOTT: 'Africa/Nouakchott' as TimeZoneEnum,
        AFRICA_OUAGADOUGOU: 'Africa/Ouagadougou' as TimeZoneEnum,
        AFRICA_PORTO_NOVO: 'Africa/Porto-Novo' as TimeZoneEnum,
        AFRICA_SAO_TOME: 'Africa/Sao_Tome' as TimeZoneEnum,
        AFRICA_TIMBUKTU: 'Africa/Timbuktu' as TimeZoneEnum,
        AFRICA_TRIPOLI: 'Africa/Tripoli' as TimeZoneEnum,
        AFRICA_TUNIS: 'Africa/Tunis' as TimeZoneEnum,
        AFRICA_WINDHOEK: 'Africa/Windhoek' as TimeZoneEnum,
        AMERICA_ADAK: 'America/Adak' as TimeZoneEnum,
        AMERICA_ANCHORAGE: 'America/Anchorage' as TimeZoneEnum,
        AMERICA_ANGUILLA: 'America/Anguilla' as TimeZoneEnum,
        AMERICA_ANTIGUA: 'America/Antigua' as TimeZoneEnum,
        AMERICA_ARAGUAINA: 'America/Araguaina' as TimeZoneEnum,
        AMERICA_ARGENTINA_BUENOS_AIRES: 'America/Argentina/Buenos_Aires' as TimeZoneEnum,
        AMERICA_ARGENTINA_CATAMARCA: 'America/Argentina/Catamarca' as TimeZoneEnum,
        AMERICA_ARGENTINA_COMOD_RIVADAVIA: 'America/Argentina/ComodRivadavia' as TimeZoneEnum,
        AMERICA_ARGENTINA_CORDOBA: 'America/Argentina/Cordoba' as TimeZoneEnum,
        AMERICA_ARGENTINA_JUJUY: 'America/Argentina/Jujuy' as TimeZoneEnum,
        AMERICA_ARGENTINA_LA_RIOJA: 'America/Argentina/La_Rioja' as TimeZoneEnum,
        AMERICA_ARGENTINA_MENDOZA: 'America/Argentina/Mendoza' as TimeZoneEnum,
        AMERICA_ARGENTINA_RIO_GALLEGOS: 'America/Argentina/Rio_Gallegos' as TimeZoneEnum,
        AMERICA_ARGENTINA_SALTA: 'America/Argentina/Salta' as TimeZoneEnum,
        AMERICA_ARGENTINA_SAN_JUAN: 'America/Argentina/San_Juan' as TimeZoneEnum,
        AMERICA_ARGENTINA_SAN_LUIS: 'America/Argentina/San_Luis' as TimeZoneEnum,
        AMERICA_ARGENTINA_TUCUMAN: 'America/Argentina/Tucuman' as TimeZoneEnum,
        AMERICA_ARGENTINA_USHUAIA: 'America/Argentina/Ushuaia' as TimeZoneEnum,
        AMERICA_ARUBA: 'America/Aruba' as TimeZoneEnum,
        AMERICA_ASUNCION: 'America/Asuncion' as TimeZoneEnum,
        AMERICA_ATIKOKAN: 'America/Atikokan' as TimeZoneEnum,
        AMERICA_ATKA: 'America/Atka' as TimeZoneEnum,
        AMERICA_BAHIA: 'America/Bahia' as TimeZoneEnum,
        AMERICA_BAHIA_BANDERAS: 'America/Bahia_Banderas' as TimeZoneEnum,
        AMERICA_BARBADOS: 'America/Barbados' as TimeZoneEnum,
        AMERICA_BELEM: 'America/Belem' as TimeZoneEnum,
        AMERICA_BELIZE: 'America/Belize' as TimeZoneEnum,
        AMERICA_BLANC_SABLON: 'America/Blanc-Sablon' as TimeZoneEnum,
        AMERICA_BOA_VISTA: 'America/Boa_Vista' as TimeZoneEnum,
        AMERICA_BOGOTA: 'America/Bogota' as TimeZoneEnum,
        AMERICA_BOISE: 'America/Boise' as TimeZoneEnum,
        AMERICA_BUENOS_AIRES: 'America/Buenos_Aires' as TimeZoneEnum,
        AMERICA_CAMBRIDGE_BAY: 'America/Cambridge_Bay' as TimeZoneEnum,
        AMERICA_CAMPO_GRANDE: 'America/Campo_Grande' as TimeZoneEnum,
        AMERICA_CANCUN: 'America/Cancun' as TimeZoneEnum,
        AMERICA_CARACAS: 'America/Caracas' as TimeZoneEnum,
        AMERICA_CATAMARCA: 'America/Catamarca' as TimeZoneEnum,
        AMERICA_CAYENNE: 'America/Cayenne' as TimeZoneEnum,
        AMERICA_CAYMAN: 'America/Cayman' as TimeZoneEnum,
        AMERICA_CHICAGO: 'America/Chicago' as TimeZoneEnum,
        AMERICA_CHIHUAHUA: 'America/Chihuahua' as TimeZoneEnum,
        AMERICA_CORAL_HARBOUR: 'America/Coral_Harbour' as TimeZoneEnum,
        AMERICA_CORDOBA: 'America/Cordoba' as TimeZoneEnum,
        AMERICA_COSTA_RICA: 'America/Costa_Rica' as TimeZoneEnum,
        AMERICA_CRESTON: 'America/Creston' as TimeZoneEnum,
        AMERICA_CUIABA: 'America/Cuiaba' as TimeZoneEnum,
        AMERICA_CURACAO: 'America/Curacao' as TimeZoneEnum,
        AMERICA_DANMARKSHAVN: 'America/Danmarkshavn' as TimeZoneEnum,
        AMERICA_DAWSON: 'America/Dawson' as TimeZoneEnum,
        AMERICA_DAWSON_CREEK: 'America/Dawson_Creek' as TimeZoneEnum,
        AMERICA_DENVER: 'America/Denver' as TimeZoneEnum,
        AMERICA_DETROIT: 'America/Detroit' as TimeZoneEnum,
        AMERICA_DOMINICA: 'America/Dominica' as TimeZoneEnum,
        AMERICA_EDMONTON: 'America/Edmonton' as TimeZoneEnum,
        AMERICA_EIRUNEPE: 'America/Eirunepe' as TimeZoneEnum,
        AMERICA_EL_SALVADOR: 'America/El_Salvador' as TimeZoneEnum,
        AMERICA_ENSENADA: 'America/Ensenada' as TimeZoneEnum,
        AMERICA_FORT_WAYNE: 'America/Fort_Wayne' as TimeZoneEnum,
        AMERICA_FORTALEZA: 'America/Fortaleza' as TimeZoneEnum,
        AMERICA_GLACE_BAY: 'America/Glace_Bay' as TimeZoneEnum,
        AMERICA_GODTHAB: 'America/Godthab' as TimeZoneEnum,
        AMERICA_GOOSE_BAY: 'America/Goose_Bay' as TimeZoneEnum,
        AMERICA_GRAND_TURK: 'America/Grand_Turk' as TimeZoneEnum,
        AMERICA_GRENADA: 'America/Grenada' as TimeZoneEnum,
        AMERICA_GUADELOUPE: 'America/Guadeloupe' as TimeZoneEnum,
        AMERICA_GUATEMALA: 'America/Guatemala' as TimeZoneEnum,
        AMERICA_GUAYAQUIL: 'America/Guayaquil' as TimeZoneEnum,
        AMERICA_GUYANA: 'America/Guyana' as TimeZoneEnum,
        AMERICA_HALIFAX: 'America/Halifax' as TimeZoneEnum,
        AMERICA_HAVANA: 'America/Havana' as TimeZoneEnum,
        AMERICA_HERMOSILLO: 'America/Hermosillo' as TimeZoneEnum,
        AMERICA_INDIANA_INDIANAPOLIS: 'America/Indiana/Indianapolis' as TimeZoneEnum,
        AMERICA_INDIANA_KNOX: 'America/Indiana/Knox' as TimeZoneEnum,
        AMERICA_INDIANA_MARENGO: 'America/Indiana/Marengo' as TimeZoneEnum,
        AMERICA_INDIANA_PETERSBURG: 'America/Indiana/Petersburg' as TimeZoneEnum,
        AMERICA_INDIANA_TELL_CITY: 'America/Indiana/Tell_City' as TimeZoneEnum,
        AMERICA_INDIANA_VEVAY: 'America/Indiana/Vevay' as TimeZoneEnum,
        AMERICA_INDIANA_VINCENNES: 'America/Indiana/Vincennes' as TimeZoneEnum,
        AMERICA_INDIANA_WINAMAC: 'America/Indiana/Winamac' as TimeZoneEnum,
        AMERICA_INDIANAPOLIS: 'America/Indianapolis' as TimeZoneEnum,
        AMERICA_INUVIK: 'America/Inuvik' as TimeZoneEnum,
        AMERICA_IQALUIT: 'America/Iqaluit' as TimeZoneEnum,
        AMERICA_JAMAICA: 'America/Jamaica' as TimeZoneEnum,
        AMERICA_JUJUY: 'America/Jujuy' as TimeZoneEnum,
        AMERICA_JUNEAU: 'America/Juneau' as TimeZoneEnum,
        AMERICA_KENTUCKY_LOUISVILLE: 'America/Kentucky/Louisville' as TimeZoneEnum,
        AMERICA_KENTUCKY_MONTICELLO: 'America/Kentucky/Monticello' as TimeZoneEnum,
        AMERICA_KNOX_IN: 'America/Knox_IN' as TimeZoneEnum,
        AMERICA_KRALENDIJK: 'America/Kralendijk' as TimeZoneEnum,
        AMERICA_LA_PAZ: 'America/La_Paz' as TimeZoneEnum,
        AMERICA_LIMA: 'America/Lima' as TimeZoneEnum,
        AMERICA_LOS_ANGELES: 'America/Los_Angeles' as TimeZoneEnum,
        AMERICA_LOUISVILLE: 'America/Louisville' as TimeZoneEnum,
        AMERICA_LOWER_PRINCES: 'America/Lower_Princes' as TimeZoneEnum,
        AMERICA_MACEIO: 'America/Maceio' as TimeZoneEnum,
        AMERICA_MANAGUA: 'America/Managua' as TimeZoneEnum,
        AMERICA_MANAUS: 'America/Manaus' as TimeZoneEnum,
        AMERICA_MARIGOT: 'America/Marigot' as TimeZoneEnum,
        AMERICA_MARTINIQUE: 'America/Martinique' as TimeZoneEnum,
        AMERICA_MATAMOROS: 'America/Matamoros' as TimeZoneEnum,
        AMERICA_MAZATLAN: 'America/Mazatlan' as TimeZoneEnum,
        AMERICA_MENDOZA: 'America/Mendoza' as TimeZoneEnum,
        AMERICA_MENOMINEE: 'America/Menominee' as TimeZoneEnum,
        AMERICA_MERIDA: 'America/Merida' as TimeZoneEnum,
        AMERICA_METLAKATLA: 'America/Metlakatla' as TimeZoneEnum,
        AMERICA_MEXICO_CITY: 'America/Mexico_City' as TimeZoneEnum,
        AMERICA_MIQUELON: 'America/Miquelon' as TimeZoneEnum,
        AMERICA_MONCTON: 'America/Moncton' as TimeZoneEnum,
        AMERICA_MONTERREY: 'America/Monterrey' as TimeZoneEnum,
        AMERICA_MONTEVIDEO: 'America/Montevideo' as TimeZoneEnum,
        AMERICA_MONTREAL: 'America/Montreal' as TimeZoneEnum,
        AMERICA_MONTSERRAT: 'America/Montserrat' as TimeZoneEnum,
        AMERICA_NASSAU: 'America/Nassau' as TimeZoneEnum,
        AMERICA_NEW_YORK: 'America/New_York' as TimeZoneEnum,
        AMERICA_NIPIGON: 'America/Nipigon' as TimeZoneEnum,
        AMERICA_NOME: 'America/Nome' as TimeZoneEnum,
        AMERICA_NORONHA: 'America/Noronha' as TimeZoneEnum,
        AMERICA_NORTH_DAKOTA_BEULAH: 'America/North_Dakota/Beulah' as TimeZoneEnum,
        AMERICA_NORTH_DAKOTA_CENTER: 'America/North_Dakota/Center' as TimeZoneEnum,
        AMERICA_NORTH_DAKOTA_NEW_SALEM: 'America/North_Dakota/New_Salem' as TimeZoneEnum,
        AMERICA_OJINAGA: 'America/Ojinaga' as TimeZoneEnum,
        AMERICA_PANAMA: 'America/Panama' as TimeZoneEnum,
        AMERICA_PANGNIRTUNG: 'America/Pangnirtung' as TimeZoneEnum,
        AMERICA_PARAMARIBO: 'America/Paramaribo' as TimeZoneEnum,
        AMERICA_PHOENIX: 'America/Phoenix' as TimeZoneEnum,
        AMERICA_PORT_AU_PRINCE: 'America/Port-au-Prince' as TimeZoneEnum,
        AMERICA_PORT_OF_SPAIN: 'America/Port_of_Spain' as TimeZoneEnum,
        AMERICA_PORTO_ACRE: 'America/Porto_Acre' as TimeZoneEnum,
        AMERICA_PORTO_VELHO: 'America/Porto_Velho' as TimeZoneEnum,
        AMERICA_PUERTO_RICO: 'America/Puerto_Rico' as TimeZoneEnum,
        AMERICA_RAINY_RIVER: 'America/Rainy_River' as TimeZoneEnum,
        AMERICA_RANKIN_INLET: 'America/Rankin_Inlet' as TimeZoneEnum,
        AMERICA_RECIFE: 'America/Recife' as TimeZoneEnum,
        AMERICA_REGINA: 'America/Regina' as TimeZoneEnum,
        AMERICA_RESOLUTE: 'America/Resolute' as TimeZoneEnum,
        AMERICA_RIO_BRANCO: 'America/Rio_Branco' as TimeZoneEnum,
        AMERICA_ROSARIO: 'America/Rosario' as TimeZoneEnum,
        AMERICA_SANTA_ISABEL: 'America/Santa_Isabel' as TimeZoneEnum,
        AMERICA_SANTAREM: 'America/Santarem' as TimeZoneEnum,
        AMERICA_SANTIAGO: 'America/Santiago' as TimeZoneEnum,
        AMERICA_SANTO_DOMINGO: 'America/Santo_Domingo' as TimeZoneEnum,
        AMERICA_SAO_PAULO: 'America/Sao_Paulo' as TimeZoneEnum,
        AMERICA_SCORESBYSUND: 'America/Scoresbysund' as TimeZoneEnum,
        AMERICA_SHIPROCK: 'America/Shiprock' as TimeZoneEnum,
        AMERICA_SITKA: 'America/Sitka' as TimeZoneEnum,
        AMERICA_ST_BARTHELEMY: 'America/St_Barthelemy' as TimeZoneEnum,
        AMERICA_ST_JOHNS: 'America/St_Johns' as TimeZoneEnum,
        AMERICA_ST_KITTS: 'America/St_Kitts' as TimeZoneEnum,
        AMERICA_ST_LUCIA: 'America/St_Lucia' as TimeZoneEnum,
        AMERICA_ST_THOMAS: 'America/St_Thomas' as TimeZoneEnum,
        AMERICA_ST_VINCENT: 'America/St_Vincent' as TimeZoneEnum,
        AMERICA_SWIFT_CURRENT: 'America/Swift_Current' as TimeZoneEnum,
        AMERICA_TEGUCIGALPA: 'America/Tegucigalpa' as TimeZoneEnum,
        AMERICA_THULE: 'America/Thule' as TimeZoneEnum,
        AMERICA_THUNDER_BAY: 'America/Thunder_Bay' as TimeZoneEnum,
        AMERICA_TIJUANA: 'America/Tijuana' as TimeZoneEnum,
        AMERICA_TORONTO: 'America/Toronto' as TimeZoneEnum,
        AMERICA_TORTOLA: 'America/Tortola' as TimeZoneEnum,
        AMERICA_VANCOUVER: 'America/Vancouver' as TimeZoneEnum,
        AMERICA_VIRGIN: 'America/Virgin' as TimeZoneEnum,
        AMERICA_WHITEHORSE: 'America/Whitehorse' as TimeZoneEnum,
        AMERICA_WINNIPEG: 'America/Winnipeg' as TimeZoneEnum,
        AMERICA_YAKUTAT: 'America/Yakutat' as TimeZoneEnum,
        AMERICA_YELLOWKNIFE: 'America/Yellowknife' as TimeZoneEnum,
        ANTARCTICA_CASEY: 'Antarctica/Casey' as TimeZoneEnum,
        ANTARCTICA_DAVIS: 'Antarctica/Davis' as TimeZoneEnum,
        ANTARCTICA_DUMONT_D_URVILLE: 'Antarctica/DumontDUrville' as TimeZoneEnum,
        ANTARCTICA_MACQUARIE: 'Antarctica/Macquarie' as TimeZoneEnum,
        ANTARCTICA_MAWSON: 'Antarctica/Mawson' as TimeZoneEnum,
        ANTARCTICA_MC_MURDO: 'Antarctica/McMurdo' as TimeZoneEnum,
        ANTARCTICA_PALMER: 'Antarctica/Palmer' as TimeZoneEnum,
        ANTARCTICA_ROTHERA: 'Antarctica/Rothera' as TimeZoneEnum,
        ANTARCTICA_SOUTH_POLE: 'Antarctica/South_Pole' as TimeZoneEnum,
        ANTARCTICA_SYOWA: 'Antarctica/Syowa' as TimeZoneEnum,
        ANTARCTICA_TROLL: 'Antarctica/Troll' as TimeZoneEnum,
        ANTARCTICA_VOSTOK: 'Antarctica/Vostok' as TimeZoneEnum,
        ARCTIC_LONGYEARBYEN: 'Arctic/Longyearbyen' as TimeZoneEnum,
        ASIA_ADEN: 'Asia/Aden' as TimeZoneEnum,
        ASIA_ALMATY: 'Asia/Almaty' as TimeZoneEnum,
        ASIA_AMMAN: 'Asia/Amman' as TimeZoneEnum,
        ASIA_ANADYR: 'Asia/Anadyr' as TimeZoneEnum,
        ASIA_AQTAU: 'Asia/Aqtau' as TimeZoneEnum,
        ASIA_AQTOBE: 'Asia/Aqtobe' as TimeZoneEnum,
        ASIA_ASHGABAT: 'Asia/Ashgabat' as TimeZoneEnum,
        ASIA_ASHKHABAD: 'Asia/Ashkhabad' as TimeZoneEnum,
        ASIA_BAGHDAD: 'Asia/Baghdad' as TimeZoneEnum,
        ASIA_BAHRAIN: 'Asia/Bahrain' as TimeZoneEnum,
        ASIA_BAKU: 'Asia/Baku' as TimeZoneEnum,
        ASIA_BANGKOK: 'Asia/Bangkok' as TimeZoneEnum,
        ASIA_BEIRUT: 'Asia/Beirut' as TimeZoneEnum,
        ASIA_BISHKEK: 'Asia/Bishkek' as TimeZoneEnum,
        ASIA_BRUNEI: 'Asia/Brunei' as TimeZoneEnum,
        ASIA_CALCUTTA: 'Asia/Calcutta' as TimeZoneEnum,
        ASIA_CHITA: 'Asia/Chita' as TimeZoneEnum,
        ASIA_CHOIBALSAN: 'Asia/Choibalsan' as TimeZoneEnum,
        ASIA_CHONGQING: 'Asia/Chongqing' as TimeZoneEnum,
        ASIA_CHUNGKING: 'Asia/Chungking' as TimeZoneEnum,
        ASIA_COLOMBO: 'Asia/Colombo' as TimeZoneEnum,
        ASIA_DACCA: 'Asia/Dacca' as TimeZoneEnum,
        ASIA_DAMASCUS: 'Asia/Damascus' as TimeZoneEnum,
        ASIA_DHAKA: 'Asia/Dhaka' as TimeZoneEnum,
        ASIA_DILI: 'Asia/Dili' as TimeZoneEnum,
        ASIA_DUBAI: 'Asia/Dubai' as TimeZoneEnum,
        ASIA_DUSHANBE: 'Asia/Dushanbe' as TimeZoneEnum,
        ASIA_GAZA: 'Asia/Gaza' as TimeZoneEnum,
        ASIA_HARBIN: 'Asia/Harbin' as TimeZoneEnum,
        ASIA_HEBRON: 'Asia/Hebron' as TimeZoneEnum,
        ASIA_HO_CHI_MINH: 'Asia/Ho_Chi_Minh' as TimeZoneEnum,
        ASIA_HONG_KONG: 'Asia/Hong_Kong' as TimeZoneEnum,
        ASIA_HOVD: 'Asia/Hovd' as TimeZoneEnum,
        ASIA_IRKUTSK: 'Asia/Irkutsk' as TimeZoneEnum,
        ASIA_ISTANBUL: 'Asia/Istanbul' as TimeZoneEnum,
        ASIA_JAKARTA: 'Asia/Jakarta' as TimeZoneEnum,
        ASIA_JAYAPURA: 'Asia/Jayapura' as TimeZoneEnum,
        ASIA_JERUSALEM: 'Asia/Jerusalem' as TimeZoneEnum,
        ASIA_KABUL: 'Asia/Kabul' as TimeZoneEnum,
        ASIA_KAMCHATKA: 'Asia/Kamchatka' as TimeZoneEnum,
        ASIA_KARACHI: 'Asia/Karachi' as TimeZoneEnum,
        ASIA_KASHGAR: 'Asia/Kashgar' as TimeZoneEnum,
        ASIA_KATHMANDU: 'Asia/Kathmandu' as TimeZoneEnum,
        ASIA_KATMANDU: 'Asia/Katmandu' as TimeZoneEnum,
        ASIA_KHANDYGA: 'Asia/Khandyga' as TimeZoneEnum,
        ASIA_KOLKATA: 'Asia/Kolkata' as TimeZoneEnum,
        ASIA_KRASNOYARSK: 'Asia/Krasnoyarsk' as TimeZoneEnum,
        ASIA_KUALA_LUMPUR: 'Asia/Kuala_Lumpur' as TimeZoneEnum,
        ASIA_KUCHING: 'Asia/Kuching' as TimeZoneEnum,
        ASIA_KUWAIT: 'Asia/Kuwait' as TimeZoneEnum,
        ASIA_MACAO: 'Asia/Macao' as TimeZoneEnum,
        ASIA_MACAU: 'Asia/Macau' as TimeZoneEnum,
        ASIA_MAGADAN: 'Asia/Magadan' as TimeZoneEnum,
        ASIA_MAKASSAR: 'Asia/Makassar' as TimeZoneEnum,
        ASIA_MANILA: 'Asia/Manila' as TimeZoneEnum,
        ASIA_MUSCAT: 'Asia/Muscat' as TimeZoneEnum,
        ASIA_NICOSIA: 'Asia/Nicosia' as TimeZoneEnum,
        ASIA_NOVOKUZNETSK: 'Asia/Novokuznetsk' as TimeZoneEnum,
        ASIA_NOVOSIBIRSK: 'Asia/Novosibirsk' as TimeZoneEnum,
        ASIA_OMSK: 'Asia/Omsk' as TimeZoneEnum,
        ASIA_ORAL: 'Asia/Oral' as TimeZoneEnum,
        ASIA_PHNOM_PENH: 'Asia/Phnom_Penh' as TimeZoneEnum,
        ASIA_PONTIANAK: 'Asia/Pontianak' as TimeZoneEnum,
        ASIA_PYONGYANG: 'Asia/Pyongyang' as TimeZoneEnum,
        ASIA_QATAR: 'Asia/Qatar' as TimeZoneEnum,
        ASIA_QYZYLORDA: 'Asia/Qyzylorda' as TimeZoneEnum,
        ASIA_RANGOON: 'Asia/Rangoon' as TimeZoneEnum,
        ASIA_RIYADH: 'Asia/Riyadh' as TimeZoneEnum,
        ASIA_SAIGON: 'Asia/Saigon' as TimeZoneEnum,
        ASIA_SAKHALIN: 'Asia/Sakhalin' as TimeZoneEnum,
        ASIA_SAMARKAND: 'Asia/Samarkand' as TimeZoneEnum,
        ASIA_SEOUL: 'Asia/Seoul' as TimeZoneEnum,
        ASIA_SHANGHAI: 'Asia/Shanghai' as TimeZoneEnum,
        ASIA_SINGAPORE: 'Asia/Singapore' as TimeZoneEnum,
        ASIA_SREDNEKOLYMSK: 'Asia/Srednekolymsk' as TimeZoneEnum,
        ASIA_TAIPEI: 'Asia/Taipei' as TimeZoneEnum,
        ASIA_TASHKENT: 'Asia/Tashkent' as TimeZoneEnum,
        ASIA_TBILISI: 'Asia/Tbilisi' as TimeZoneEnum,
        ASIA_TEHRAN: 'Asia/Tehran' as TimeZoneEnum,
        ASIA_TEL_AVIV: 'Asia/Tel_Aviv' as TimeZoneEnum,
        ASIA_THIMBU: 'Asia/Thimbu' as TimeZoneEnum,
        ASIA_THIMPHU: 'Asia/Thimphu' as TimeZoneEnum,
        ASIA_TOKYO: 'Asia/Tokyo' as TimeZoneEnum,
        ASIA_UJUNG_PANDANG: 'Asia/Ujung_Pandang' as TimeZoneEnum,
        ASIA_ULAANBAATAR: 'Asia/Ulaanbaatar' as TimeZoneEnum,
        ASIA_ULAN_BATOR: 'Asia/Ulan_Bator' as TimeZoneEnum,
        ASIA_URUMQI: 'Asia/Urumqi' as TimeZoneEnum,
        ASIA_UST_NERA: 'Asia/Ust-Nera' as TimeZoneEnum,
        ASIA_VIENTIANE: 'Asia/Vientiane' as TimeZoneEnum,
        ASIA_VLADIVOSTOK: 'Asia/Vladivostok' as TimeZoneEnum,
        ASIA_YAKUTSK: 'Asia/Yakutsk' as TimeZoneEnum,
        ASIA_YEKATERINBURG: 'Asia/Yekaterinburg' as TimeZoneEnum,
        ASIA_YEREVAN: 'Asia/Yerevan' as TimeZoneEnum,
        ATLANTIC_AZORES: 'Atlantic/Azores' as TimeZoneEnum,
        ATLANTIC_BERMUDA: 'Atlantic/Bermuda' as TimeZoneEnum,
        ATLANTIC_CANARY: 'Atlantic/Canary' as TimeZoneEnum,
        ATLANTIC_CAPE_VERDE: 'Atlantic/Cape_Verde' as TimeZoneEnum,
        ATLANTIC_FAEROE: 'Atlantic/Faeroe' as TimeZoneEnum,
        ATLANTIC_FAROE: 'Atlantic/Faroe' as TimeZoneEnum,
        ATLANTIC_JAN_MAYEN: 'Atlantic/Jan_Mayen' as TimeZoneEnum,
        ATLANTIC_MADEIRA: 'Atlantic/Madeira' as TimeZoneEnum,
        ATLANTIC_REYKJAVIK: 'Atlantic/Reykjavik' as TimeZoneEnum,
        ATLANTIC_SOUTH_GEORGIA: 'Atlantic/South_Georgia' as TimeZoneEnum,
        ATLANTIC_ST_HELENA: 'Atlantic/St_Helena' as TimeZoneEnum,
        ATLANTIC_STANLEY: 'Atlantic/Stanley' as TimeZoneEnum,
        AUSTRALIA_ACT: 'Australia/ACT' as TimeZoneEnum,
        AUSTRALIA_ADELAIDE: 'Australia/Adelaide' as TimeZoneEnum,
        AUSTRALIA_BRISBANE: 'Australia/Brisbane' as TimeZoneEnum,
        AUSTRALIA_BROKEN_HILL: 'Australia/Broken_Hill' as TimeZoneEnum,
        AUSTRALIA_CANBERRA: 'Australia/Canberra' as TimeZoneEnum,
        AUSTRALIA_CURRIE: 'Australia/Currie' as TimeZoneEnum,
        AUSTRALIA_DARWIN: 'Australia/Darwin' as TimeZoneEnum,
        AUSTRALIA_EUCLA: 'Australia/Eucla' as TimeZoneEnum,
        AUSTRALIA_HOBART: 'Australia/Hobart' as TimeZoneEnum,
        AUSTRALIA_LHI: 'Australia/LHI' as TimeZoneEnum,
        AUSTRALIA_LINDEMAN: 'Australia/Lindeman' as TimeZoneEnum,
        AUSTRALIA_LORD_HOWE: 'Australia/Lord_Howe' as TimeZoneEnum,
        AUSTRALIA_MELBOURNE: 'Australia/Melbourne' as TimeZoneEnum,
        AUSTRALIA_NSW: 'Australia/NSW' as TimeZoneEnum,
        AUSTRALIA_NORTH: 'Australia/North' as TimeZoneEnum,
        AUSTRALIA_PERTH: 'Australia/Perth' as TimeZoneEnum,
        AUSTRALIA_QUEENSLAND: 'Australia/Queensland' as TimeZoneEnum,
        AUSTRALIA_SOUTH: 'Australia/South' as TimeZoneEnum,
        AUSTRALIA_SYDNEY: 'Australia/Sydney' as TimeZoneEnum,
        AUSTRALIA_TASMANIA: 'Australia/Tasmania' as TimeZoneEnum,
        AUSTRALIA_VICTORIA: 'Australia/Victoria' as TimeZoneEnum,
        AUSTRALIA_WEST: 'Australia/West' as TimeZoneEnum,
        AUSTRALIA_YANCOWINNA: 'Australia/Yancowinna' as TimeZoneEnum,
        BRAZIL_ACRE: 'Brazil/Acre' as TimeZoneEnum,
        BRAZIL_DE_NORONHA: 'Brazil/DeNoronha' as TimeZoneEnum,
        BRAZIL_EAST: 'Brazil/East' as TimeZoneEnum,
        BRAZIL_WEST: 'Brazil/West' as TimeZoneEnum,
        CANADA_ATLANTIC: 'Canada/Atlantic' as TimeZoneEnum,
        CANADA_CENTRAL: 'Canada/Central' as TimeZoneEnum,
        CANADA_EAST_SASKATCHEWAN: 'Canada/East-Saskatchewan' as TimeZoneEnum,
        CANADA_EASTERN: 'Canada/Eastern' as TimeZoneEnum,
        CANADA_MOUNTAIN: 'Canada/Mountain' as TimeZoneEnum,
        CANADA_NEWFOUNDLAND: 'Canada/Newfoundland' as TimeZoneEnum,
        CANADA_PACIFIC: 'Canada/Pacific' as TimeZoneEnum,
        CANADA_SASKATCHEWAN: 'Canada/Saskatchewan' as TimeZoneEnum,
        CANADA_YUKON: 'Canada/Yukon' as TimeZoneEnum,
        CHILE_CONTINENTAL: 'Chile/Continental' as TimeZoneEnum,
        CHILE_EASTER_ISLAND: 'Chile/EasterIsland' as TimeZoneEnum,
        ETC_GMT: 'Etc/GMT' as TimeZoneEnum,
        ETC_GMT0: 'Etc/GMT+0' as TimeZoneEnum,
        ETC_GMT1: 'Etc/GMT+1' as TimeZoneEnum,
        ETC_GMT10: 'Etc/GMT+10' as TimeZoneEnum,
        ETC_GMT11: 'Etc/GMT+11' as TimeZoneEnum,
        ETC_GMT12: 'Etc/GMT+12' as TimeZoneEnum,
        ETC_GMT2: 'Etc/GMT+2' as TimeZoneEnum,
        ETC_GMT3: 'Etc/GMT+3' as TimeZoneEnum,
        ETC_GMT4: 'Etc/GMT+4' as TimeZoneEnum,
        ETC_GMT5: 'Etc/GMT+5' as TimeZoneEnum,
        ETC_GMT6: 'Etc/GMT+6' as TimeZoneEnum,
        ETC_GMT7: 'Etc/GMT+7' as TimeZoneEnum,
        ETC_GMT8: 'Etc/GMT+8' as TimeZoneEnum,
        ETC_GMT9: 'Etc/GMT+9' as TimeZoneEnum,
        ETC_GMT_0: 'Etc/GMT-0' as TimeZoneEnum,
        ETC_GMT_1: 'Etc/GMT-1' as TimeZoneEnum,
        ETC_GMT_10: 'Etc/GMT-10' as TimeZoneEnum,
        ETC_GMT_11: 'Etc/GMT-11' as TimeZoneEnum,
        ETC_GMT_12: 'Etc/GMT-12' as TimeZoneEnum,
        ETC_GMT_13: 'Etc/GMT-13' as TimeZoneEnum,
        ETC_GMT_14: 'Etc/GMT-14' as TimeZoneEnum,
        ETC_GMT_2: 'Etc/GMT-2' as TimeZoneEnum,
        ETC_GMT_3: 'Etc/GMT-3' as TimeZoneEnum,
        ETC_GMT_4: 'Etc/GMT-4' as TimeZoneEnum,
        ETC_GMT_5: 'Etc/GMT-5' as TimeZoneEnum,
        ETC_GMT_6: 'Etc/GMT-6' as TimeZoneEnum,
        ETC_GMT_7: 'Etc/GMT-7' as TimeZoneEnum,
        ETC_GMT_8: 'Etc/GMT-8' as TimeZoneEnum,
        ETC_GMT_9: 'Etc/GMT-9' as TimeZoneEnum,
        ETC_GREENWICH: 'Etc/Greenwich' as TimeZoneEnum,
        ETC_UCT: 'Etc/UCT' as TimeZoneEnum,
        ETC_UTC: 'Etc/UTC' as TimeZoneEnum,
        ETC_UNIVERSAL: 'Etc/Universal' as TimeZoneEnum,
        ETC_ZULU: 'Etc/Zulu' as TimeZoneEnum,
        EUROPE_AMSTERDAM: 'Europe/Amsterdam' as TimeZoneEnum,
        EUROPE_ANDORRA: 'Europe/Andorra' as TimeZoneEnum,
        EUROPE_ATHENS: 'Europe/Athens' as TimeZoneEnum,
        EUROPE_BELFAST: 'Europe/Belfast' as TimeZoneEnum,
        EUROPE_BELGRADE: 'Europe/Belgrade' as TimeZoneEnum,
        EUROPE_BERLIN: 'Europe/Berlin' as TimeZoneEnum,
        EUROPE_BRATISLAVA: 'Europe/Bratislava' as TimeZoneEnum,
        EUROPE_BRUSSELS: 'Europe/Brussels' as TimeZoneEnum,
        EUROPE_BUCHAREST: 'Europe/Bucharest' as TimeZoneEnum,
        EUROPE_BUDAPEST: 'Europe/Budapest' as TimeZoneEnum,
        EUROPE_BUSINGEN: 'Europe/Busingen' as TimeZoneEnum,
        EUROPE_CHISINAU: 'Europe/Chisinau' as TimeZoneEnum,
        EUROPE_COPENHAGEN: 'Europe/Copenhagen' as TimeZoneEnum,
        EUROPE_DUBLIN: 'Europe/Dublin' as TimeZoneEnum,
        EUROPE_GIBRALTAR: 'Europe/Gibraltar' as TimeZoneEnum,
        EUROPE_GUERNSEY: 'Europe/Guernsey' as TimeZoneEnum,
        EUROPE_HELSINKI: 'Europe/Helsinki' as TimeZoneEnum,
        EUROPE_ISLE_OF_MAN: 'Europe/Isle_of_Man' as TimeZoneEnum,
        EUROPE_ISTANBUL: 'Europe/Istanbul' as TimeZoneEnum,
        EUROPE_JERSEY: 'Europe/Jersey' as TimeZoneEnum,
        EUROPE_KALININGRAD: 'Europe/Kaliningrad' as TimeZoneEnum,
        EUROPE_KIEV: 'Europe/Kiev' as TimeZoneEnum,
        EUROPE_LISBON: 'Europe/Lisbon' as TimeZoneEnum,
        EUROPE_LJUBLJANA: 'Europe/Ljubljana' as TimeZoneEnum,
        EUROPE_LONDON: 'Europe/London' as TimeZoneEnum,
        EUROPE_LUXEMBOURG: 'Europe/Luxembourg' as TimeZoneEnum,
        EUROPE_MADRID: 'Europe/Madrid' as TimeZoneEnum,
        EUROPE_MALTA: 'Europe/Malta' as TimeZoneEnum,
        EUROPE_MARIEHAMN: 'Europe/Mariehamn' as TimeZoneEnum,
        EUROPE_MINSK: 'Europe/Minsk' as TimeZoneEnum,
        EUROPE_MONACO: 'Europe/Monaco' as TimeZoneEnum,
        EUROPE_MOSCOW: 'Europe/Moscow' as TimeZoneEnum,
        EUROPE_NICOSIA: 'Europe/Nicosia' as TimeZoneEnum,
        EUROPE_OSLO: 'Europe/Oslo' as TimeZoneEnum,
        EUROPE_PARIS: 'Europe/Paris' as TimeZoneEnum,
        EUROPE_PODGORICA: 'Europe/Podgorica' as TimeZoneEnum,
        EUROPE_PRAGUE: 'Europe/Prague' as TimeZoneEnum,
        EUROPE_RIGA: 'Europe/Riga' as TimeZoneEnum,
        EUROPE_ROME: 'Europe/Rome' as TimeZoneEnum,
        EUROPE_SAMARA: 'Europe/Samara' as TimeZoneEnum,
        EUROPE_SAN_MARINO: 'Europe/San_Marino' as TimeZoneEnum,
        EUROPE_SARAJEVO: 'Europe/Sarajevo' as TimeZoneEnum,
        EUROPE_SIMFEROPOL: 'Europe/Simferopol' as TimeZoneEnum,
        EUROPE_SKOPJE: 'Europe/Skopje' as TimeZoneEnum,
        EUROPE_SOFIA: 'Europe/Sofia' as TimeZoneEnum,
        EUROPE_STOCKHOLM: 'Europe/Stockholm' as TimeZoneEnum,
        EUROPE_TALLINN: 'Europe/Tallinn' as TimeZoneEnum,
        EUROPE_TIRANE: 'Europe/Tirane' as TimeZoneEnum,
        EUROPE_TIRASPOL: 'Europe/Tiraspol' as TimeZoneEnum,
        EUROPE_UZHGOROD: 'Europe/Uzhgorod' as TimeZoneEnum,
        EUROPE_VADUZ: 'Europe/Vaduz' as TimeZoneEnum,
        EUROPE_VATICAN: 'Europe/Vatican' as TimeZoneEnum,
        EUROPE_VIENNA: 'Europe/Vienna' as TimeZoneEnum,
        EUROPE_VILNIUS: 'Europe/Vilnius' as TimeZoneEnum,
        EUROPE_VOLGOGRAD: 'Europe/Volgograd' as TimeZoneEnum,
        EUROPE_WARSAW: 'Europe/Warsaw' as TimeZoneEnum,
        EUROPE_ZAGREB: 'Europe/Zagreb' as TimeZoneEnum,
        EUROPE_ZAPOROZHYE: 'Europe/Zaporozhye' as TimeZoneEnum,
        EUROPE_ZURICH: 'Europe/Zurich' as TimeZoneEnum,
        INDIAN_ANTANANARIVO: 'Indian/Antananarivo' as TimeZoneEnum,
        INDIAN_CHAGOS: 'Indian/Chagos' as TimeZoneEnum,
        INDIAN_CHRISTMAS: 'Indian/Christmas' as TimeZoneEnum,
        INDIAN_COCOS: 'Indian/Cocos' as TimeZoneEnum,
        INDIAN_COMORO: 'Indian/Comoro' as TimeZoneEnum,
        INDIAN_KERGUELEN: 'Indian/Kerguelen' as TimeZoneEnum,
        INDIAN_MAHE: 'Indian/Mahe' as TimeZoneEnum,
        INDIAN_MALDIVES: 'Indian/Maldives' as TimeZoneEnum,
        INDIAN_MAURITIUS: 'Indian/Mauritius' as TimeZoneEnum,
        INDIAN_MAYOTTE: 'Indian/Mayotte' as TimeZoneEnum,
        INDIAN_REUNION: 'Indian/Reunion' as TimeZoneEnum,
        MEXICO_BAJA_NORTE: 'Mexico/BajaNorte' as TimeZoneEnum,
        MEXICO_BAJA_SUR: 'Mexico/BajaSur' as TimeZoneEnum,
        MEXICO_GENERAL: 'Mexico/General' as TimeZoneEnum,
        PACIFIC_APIA: 'Pacific/Apia' as TimeZoneEnum,
        PACIFIC_AUCKLAND: 'Pacific/Auckland' as TimeZoneEnum,
        PACIFIC_CHATHAM: 'Pacific/Chatham' as TimeZoneEnum,
        PACIFIC_CHUUK: 'Pacific/Chuuk' as TimeZoneEnum,
        PACIFIC_EASTER: 'Pacific/Easter' as TimeZoneEnum,
        PACIFIC_EFATE: 'Pacific/Efate' as TimeZoneEnum,
        PACIFIC_ENDERBURY: 'Pacific/Enderbury' as TimeZoneEnum,
        PACIFIC_FAKAOFO: 'Pacific/Fakaofo' as TimeZoneEnum,
        PACIFIC_FIJI: 'Pacific/Fiji' as TimeZoneEnum,
        PACIFIC_FUNAFUTI: 'Pacific/Funafuti' as TimeZoneEnum,
        PACIFIC_GALAPAGOS: 'Pacific/Galapagos' as TimeZoneEnum,
        PACIFIC_GAMBIER: 'Pacific/Gambier' as TimeZoneEnum,
        PACIFIC_GUADALCANAL: 'Pacific/Guadalcanal' as TimeZoneEnum,
        PACIFIC_GUAM: 'Pacific/Guam' as TimeZoneEnum,
        PACIFIC_HONOLULU: 'Pacific/Honolulu' as TimeZoneEnum,
        PACIFIC_JOHNSTON: 'Pacific/Johnston' as TimeZoneEnum,
        PACIFIC_KIRITIMATI: 'Pacific/Kiritimati' as TimeZoneEnum,
        PACIFIC_KOSRAE: 'Pacific/Kosrae' as TimeZoneEnum,
        PACIFIC_KWAJALEIN: 'Pacific/Kwajalein' as TimeZoneEnum,
        PACIFIC_MAJURO: 'Pacific/Majuro' as TimeZoneEnum,
        PACIFIC_MARQUESAS: 'Pacific/Marquesas' as TimeZoneEnum,
        PACIFIC_MIDWAY: 'Pacific/Midway' as TimeZoneEnum,
        PACIFIC_NAURU: 'Pacific/Nauru' as TimeZoneEnum,
        PACIFIC_NIUE: 'Pacific/Niue' as TimeZoneEnum,
        PACIFIC_NORFOLK: 'Pacific/Norfolk' as TimeZoneEnum,
        PACIFIC_NOUMEA: 'Pacific/Noumea' as TimeZoneEnum,
        PACIFIC_PAGO_PAGO: 'Pacific/Pago_Pago' as TimeZoneEnum,
        PACIFIC_PALAU: 'Pacific/Palau' as TimeZoneEnum,
        PACIFIC_PITCAIRN: 'Pacific/Pitcairn' as TimeZoneEnum,
        PACIFIC_POHNPEI: 'Pacific/Pohnpei' as TimeZoneEnum,
        PACIFIC_PONAPE: 'Pacific/Ponape' as TimeZoneEnum,
        PACIFIC_PORT_MORESBY: 'Pacific/Port_Moresby' as TimeZoneEnum,
        PACIFIC_RAROTONGA: 'Pacific/Rarotonga' as TimeZoneEnum,
        PACIFIC_SAIPAN: 'Pacific/Saipan' as TimeZoneEnum,
        PACIFIC_SAMOA: 'Pacific/Samoa' as TimeZoneEnum,
        PACIFIC_TAHITI: 'Pacific/Tahiti' as TimeZoneEnum,
        PACIFIC_TARAWA: 'Pacific/Tarawa' as TimeZoneEnum,
        PACIFIC_TONGATAPU: 'Pacific/Tongatapu' as TimeZoneEnum,
        PACIFIC_TRUK: 'Pacific/Truk' as TimeZoneEnum,
        PACIFIC_WAKE: 'Pacific/Wake' as TimeZoneEnum,
        PACIFIC_WALLIS: 'Pacific/Wallis' as TimeZoneEnum,
        PACIFIC_YAP: 'Pacific/Yap' as TimeZoneEnum
    };
}


